import axios from 'axios';
// import store from '../store/index'

export default () => axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});
